<template>
  <transition name="page" mode="out-in">
    <component :is="layout" v-if="layout">
      <router-view />
    </component>
  </transition>
</template>

<script>
import SocialLayout from './layouts/web/SocialLayout'
import SocialLayoutNoHeader from './layouts/web/SocialLayoutNoHeader'
import AuthLayout from './components/auth/Layout.vue'
import BackofficeLayout from './components/backoffice/layout/BackofficeLayout.vue'

export default {
  name: 'App',
  components: {
    SocialLayout,
    SocialLayoutNoHeader,
    AuthLayout,
    BackofficeLayout,
  },
  data() {
    return {
      layout: null,
      defaultLayout: 'social-layout',
      defaultMetaTitle: "GOCHAT",
      defaultMetaDiscription: "Social Commerce"
    }
  },
  methods: {
    // setLayout(route) {
    //   if (typeof route == "undefined" || this.layout != null) {
    //     this.layout = this.defaultLayout;
    //     document.body.classList.add(this.layout);
    //   } else {
    //     this.layout = route;
    //     document.body.classList.add(this.layout);
    //   }
    // },
    setLayout(layout) {
      this.layout = layout || this.defaultLayout
      document.body.classList.add(this.layout)
    }
  },
  computed: {
    title() {
      if (this.$route.meta.suffix) return this.$t(this.$route.meta.title) + ' - ' + this.$route.meta.suffix;
      if (!this.$route.meta.suffix) return this.$t(this.$route.meta.title)
      return this.$t(this.$route.meta.title) ? this.$t(this.$route.meta.title) : this.defaultMetaTitle
    },
    metaTitle() {
      return this.$route.meta.suffix ? this.$route.meta.suffix : this.defaultMetaTitle;
    },
    metaDiscription() {
      return this.$route.meta.meta_discription ? this.$route.meta.meta_discription : this.defaultMetaDiscription;
    },
  },
  created() {
    this.setLayout(this.$setLayout.meta.layout)
  },
  watch: {
    '$route.meta.layout': function (layout) {
      // console.log('App:$route.meta.layout: ', layout)

      this.setLayout(layout)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue